module.exports = __webpack_public_path__ + "img/product7.b33886d0.jpg";